import { NewRelicActionTypes } from './newrelic.actionType';

export namespace NewRelicAnalytics {
  export class InitNewRelicAction {
    static readonly type = NewRelicActionTypes.InitNewRelic;
  }

  export class SetNewRelicActionAttributes {
    constructor(public data: any) {}
    static readonly type = NewRelicActionTypes.SetAttributes;
  }
}
